import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import { Variant, Color } from './types';

const counterSize = layout.fontSizes.base.desktop.value;

type CounterProps = {
  variant: Variant;
  color: Color;
};

export const Counter = styled.span<CounterProps>`
  padding: 0 ${counterSize / 2}px;
  border-radius: ${counterSize}px;
  font-size: ${counterSize}px;
  line-height: 1.5;

  background: ${p =>
    p.variant === Variant.DARK
      ? p.theme.buttons[p.color].bg
      : p.theme.buttons[p.color].text};
  color: ${p =>
    p.variant === Variant.DARK
      ? p.theme.buttons[p.color].text
      : p.theme.buttons[p.color].bg};
`;
